/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rooms_RoomtcodeInputs */

const fr_rooms_roomtcode = /** @type {(inputs: Rooms_RoomtcodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`roomtcode (Reservit)`)
};

const en_rooms_roomtcode = /** @type {(inputs: Rooms_RoomtcodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`roomtcode (Reservit)`)
};

/**
* | output |
* | --- |
* | "roomtcode (Reservit)" |
*
* @param {Rooms_RoomtcodeInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const rooms_roomtcode = /** @type {((inputs?: Rooms_RoomtcodeInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rooms_RoomtcodeInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_rooms_roomtcode(inputs)
	return en_rooms_roomtcode(inputs)
});